import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Instagram, Music2, Facebook } from "lucide-react";
import { LOGO_URL } from "../lib/kk";

const quick = [
  { label: "About", id: "about" },
  { label: "Puppies", id: "puppies" },
  { label: "Video", id: "video" },
  { label: "Health", id: "health" },
  { label: "FAQ", id: "faq" },
  { label: "Contact Us", id: "contact" },
];

const more = [
  { label: "Stud Service", to: "/stud-service" },
  { label: "Stud Waitlist", to: "/stud-waitlist" },
  { label: "Puppy Waitlist", to: "/puppy-waitlist" },
  { label: "Productions", to: "/productions" },
  { label: "Owner Updates", to: "/owner-updates" },
];

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const go = (id) => {
    if (location.pathname !== "/") navigate("/", { state: { scrollTo: id } });
    else document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#111111] border-t-[3px] border-t-[#BB0000] pt-14 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <img src={LOGO_URL} alt="Kallie's Kennel" className="h-[90px] w-auto object-contain mb-4" />
          <p className="kk-label text-[#A8A9AD] mb-2">Quality · Health · Temperament · Family</p>
          <p className="text-[#999999] text-sm">Columbus, Ohio</p>
        </div>

        <div>
          <h4 className="kk-heading text-lg mb-4">Quick Links</h4>
          <ul className="space-y-2">
            {quick.map((l) => (
              <li key={l.id}>
                <button onClick={() => go(l.id)} className="text-[#A8A9AD] hover:text-[#BB0000] transition-colors text-sm">
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="kk-heading text-lg mb-4">More</h4>
          <ul className="space-y-2">
            {more.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-[#A8A9AD] hover:text-[#BB0000] transition-colors text-sm">
                  {l.label}
                </Link>
              </li>
            ))}
            <li className="flex items-center gap-4 pt-2">
              <a href="#" className="text-[#A8A9AD] hover:text-[#BB0000]" aria-label="Instagram"><Instagram size={20} /></a>
              <a href="#" className="text-[#A8A9AD] hover:text-[#BB0000]" aria-label="TikTok"><Music2 size={20} /></a>
              <a href="#" className="text-[#A8A9AD] hover:text-[#BB0000]" aria-label="Facebook"><Facebook size={20} /></a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-10 pt-6 border-t border-white/10 text-center">
        <p className="text-[#777] text-xs">© {new Date().getFullYear()} Kallie's Kennel · Columbus, Ohio. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
